<div style="display: flex; align-items: center;">
  <div class="toggle-switch">
    <label>
      <input type="checkbox" [checked]="checked" (change)="onToggle()" [id]="id" [name]="name"/>
      <span class="slider round"></span>
    </label>
  </div>
</div>
